// Auto-generated by robust sync script
export const migrated = {
  le_lien_de_votre_annonce_airbnb_est_obligatoire_:
    "È richiesto il collegamento al tuo annuncio Airbnb",
  la_note_airbnb_doit__tre_au_minimum_de_4_5_:
    "La valutazione di Airbnb deve essere almeno da 4 a 5",
  compte_cr______v_rifiez_votre_email_pour_activer_votre_acc_s_au_club_:
    "Crea un account controlla la tua email per attivare il tuo accesso al club",
  club_r_serv__aux_h_tes_airbnb_not_s_4_5__:
    "Club riservato agli ospiti airbnb non s'45",
  comparez_vos_gains_r_els: "Confronta i tuoi guadagni effettivi",
  le_mod_le_traveltrok_est_gagnant_gagnant___le_voya:
    "La mod traveltrok è vincente, vince il viaggiatore",
  votre_prix_sur_les_autres_sites: "Il tuo prezzo su altri siti",
  diminuer_le_prix: "Ridurre il prezzo",
  augmenter_le_prix: "Aumenta il prezzo",
  net_pour_vous: "Netto per te",
  de_commissions: "Commissioni",
  prix_pay__par_le_voyageur: "Prezzo pagato dal viaggiatore",
  revenu___d_clarer__imp_ts_: "Reddito per dichiarare le tasse",
  vous_d_clarez_100__du_prix____commissions__:
    "Dichiari il 100% delle commissioni sul prezzo",
  de_frais_h_te: "Commissioni dell'host",
  __0__compar____booking_: "0 prenotazione comparativa",
  mod_le_frais_h_te__depuis_25_____: "Modifica la tariffa host dal 25",
  vous_d_clarez_100__du_prix_voyageur_:
    "Dichiari il 100 del prezzo del passeggero",
  strat_gie_gagnante: "Strategia vincente",
  prix_voyageur: "Prezzo del viaggiatore",
  _5__pour_le_voyageur: "5 per il viaggiatore",
  le_meilleur_des_deux_mondes: "Il meglio di entrambi i mondi",
  avantage_fiscal: "Vantaggio fiscale",
  vous_d_clarez_moins__vous_payez_moins_d____imp_ts_:
    "Dichiari meno paghi meno tasse",
  sc_nario___traveltrok_applique_5__de_frais_voyageu:
    "Sc nario traveltrok applica 5 tariffe per i viaggiatori",
  appartement: "Appartamento",
  maison: "Casa",
  inclut_villa_chalet: "Include villa chalet",
  loft: "Soppalco",
  luxe: "Lusso",
  insolite: "Insolito",
  autre: "Altro",
  campagne: "Campagna",
  mer: "Mare",
  montagne: "Montagna",
  au_dessus_de_500_nuit: "Oltre € 500/notte",
  aucun_resultat_dynamique: "Nessun risultato dinamico",
  service_de_localisation_indisponible__r_essayez_da:
    "Servizio di localizzazione non disponibile, riprova tra poco",
  quel_type_de_logement_souhaitez_vou: "Che tipo di alloggio vuoi offrire?",
  choisissez_la_cat_gorie_qui_d_crit_le_mieux_votre_:
    "Scegli la categoria che meglio descrive il tuo alloggio",
  quel_est_le_cadre_du_logement__: "Com’è il contesto abitativo?",
  o__est_situ__votre_logement__: "Dove si trova il tuo alloggio?",
  pays_europ_en_de_r_f_rence: "Paese europeo di riferimento",
  ville__village__code_postal___: "Città, villaggio, codice postale...",
  recherche_en_cours___: "Ricerche in corso...",
  recherche___: "Ricerca...",
  localiser: "Individuare",
  nous_utiliserons_cette_adresse_pour_localiser_votr:
    "Utilizzeremo questo indirizzo per localizzare il tuo alloggio",
  localis_: "Localizzato",
  _copy__openstreetmap_france: "© OpenStreetMap Francia",
  emplacement_valid_: "Posizione convalidata",
  d_crivez_votre_logement: "Descrivi il tuo alloggio",
  donnez_envie_aux_voyageurs_de_s_journer_chez_vous_:
    "Fai sì che i viaggiatori vogliano soggiornare con te",
  titre_de_l__annonce: "Titolo dell'annuncio",
  ex__charmant_studio_au_c_ur_de_paris:
    "Es: Incantevole monolocale nel cuore di Parigi",
  soyez_concis_et_accrocheur: "Sii conciso e accattivante",
  description_d_taill_e: "Descrizione dettagliata",
  parlez_de_votre_logement__du_quartier__des__quipem:
    "Parla del tuo alloggio, del quartiere, dei servizi...",
  mentionnez_les_points_forts: "Citare i punti forti",
  voyageurs: "Viaggiatori",
  chambres: "Camere",
  lits: "Letti",
  salles_de_bain: "Bagni",
  d_tails_du_logement: "Dettagli dell'alloggio",
  donnez_plus_d__informations_sur_la_capacit__d__acc:
    "Fornire maggiori informazioni sulla capacità di ricezione",
  surface__m__: "Superficie (m²)",
  ex__85: "Esempio: 85",
  ajoutez_des_photos: "Aggiungi foto",
  mettez_en_valeur_votre_logement_avec_de_belles_ima:
    "Metti in risalto la tua casa con bellissime immagini",
  glissez_vos_photos_ici: "Trascina qui le tue foto",
  parcourez_vos_fichiers: "Sfoglia i tuoi file",
  jpg__png_jusqu____5_mo: "JPG, PNG (fino a 5 MB)",
  d_j__en_ligne: "Già online",
  __uploader: "Da caricare",
  fixez_votre_prix: "Imposta il tuo prezzo",
  vous_pourrez_le_modifier___tout_moment_:
    "Puoi modificarlo in qualsiasi momento",
  par_nuit: "A notte",
  aper_u_de_votre_annonce: "Visualizza l'anteprima del tuo annuncio",
  titre_de_votre_annonce: "Titolo del tuo annuncio",
  nouveau: "Nuovo",
  localisation: "Posizione",
  suppression_du_profil__tapez_supprimer_puis_confirmez__si_la_suppression_compl_te_est_impossible__votre_profil_sera_mis_en_pause_et_masque_:
    "Eliminando il tipo di profilo elimina quindi conferma se l'eliminazione completa è impossibile, il tuo profilo verrà messo in pausa e nascosto",
  suppression_compl_te_indisponible__profil_mis_en_pause_et_masque_:
    "Completa Elimina il profilo non disponibile in pausa e nascondi",
  preferences: "Preferenze",
  gerez_vos_unites__votre_visibilite_et_le_statut_de_votre_profil_:
    "Gestisci le tue unità, la tua visibilità e lo stato del tuo profilo",
  vous_restez_connecte_mais_vos_annonces_ne_sont_plus_actives_dans_les_suggestions_:
    "Rimani connesso ma i tuoi annunci non sono più attivi nei suggerimenti",
  votre_profil_et_vos_logements_ne_remontent_plus_dans_la_carte_et_les_pages_de_destinations_:
    "Il tuo profilo e i tuoi alloggi non compaiono più sulla mappa e sulle pagine di destinazione",
  base_de_donnees_non_migree__vos_preferences_sont_sauvegardees_localement_pour_l_instant_:
    "Database non migrato, per il momento le tue preferenze vengono salvate localmente",
  delai_depasse: "La scadenza è superata",
  echeance_aujourd__hui: "Scadenza oggi",
  mois_restants: "Mesi rimanenti",
  nuits_dues_et_aucun_accueil_effectue:
    "Notti dovute e nessuna ricezione effettuata",
  suivi_des_echanges: "Monitoraggio degli scambi",
  suivez_les_nuits_dues_dans_les_deux_sens__qui_vous_doit_des_nuits__qui_vous_devez_accueillir__et_le_temps_restant_pour_cl__turer_chaque_echange_:
    "Tieni traccia delle notti dovute in entrambe le direzioni a chi ti deve le notti a chi sei dovuto e al tempo rimanente per chiudere ogni scambio",
  nom__logement__contrat__dates__statut_des_deux_c_tes_et_temps_restant_:
    "Nominare le date del contratto di alloggio, lo stato di entrambe le parti e il tempo rimanente",
  visualisez_vos_villes_cibles_et_les_rayons_de_recherche_autour_de_chaque_point_:
    "Visualizza le tue città target e cerca i raggi attorno a ciascun punto",
  __d_couvrir___: "coprire",
  les_incontournables___visiter_lors_de_votre_s_jour:
    "I luoghi essenziali da visitare durante il vostro soggiorno",
  impossible_de_finaliser_la_demande__r_essaie_dans_:
    "Impossibile finalizzare la richiesta, riprovare",
  r_server_ton_s_jour___: "prenota il tuo soggiorno",
  parcours_simple_en_3__tapes__recherche__d_tails__v:
    "Ricerca semplice dei dettagli in 3 passaggi v",
  recherche: "Ricerca",
  validation: "Validazione",
  demande_envoy_e: "Richiesta inviata",
  un_h_te_va_te_r_pondre_rapidement_avec_les_d_tails:
    "Un host risponderà rapidamente con i dettagli",
  cr_er_une_nouvelle_demande: "creare una nuova richiesta",
  "1__ton_s_jour": "1 giorno",
  arriv_e: "Arrivo",
  pers_: "Persone",
  dates_flexibles: "Date flessibili",
  dates_exactes: "Date esatte",
  _3_jours: "3 giorni",
  _7_jours: "7 giorni",
  _14_jours: "14 giorni",
  je_voyage_avec_des_animaux: "Viaggio con gli animali",
  "2__infos_r_servation": "2 informazioni sulla prenotazione",
  nom_complet: "Nome e cognome",
  ex__clara_martin: "ex clara martin",
  message___l_h_te: "Invia un messaggio all'host",
  pr_sentation_rapide__heure_d_arriv_e__besoins_part:
    "L'orario di arrivo della presentazione rapida richiede una parte",
  "3__validation_de_la_r_servation": "3 convalida della prenotazione",
  destination: "Destinazione",
  s_jour: "rimanere",
  flexibilit_: "Flessibilità",
  tarification_traveltrok: "prezzi di traveltrok",
  frais_plateforme: "Commissioni della piattaforma",
  "1eur_voyageur___1eur_h_te": "1il loro viaggiatore 1il loro ospite",
  incluse: "Incluso",
  total_estim_: "Stima totale",
  continuer: "Continuare",
  envoi___: "Invio",
  confirmer_ma_r_servation: "Conferma la mia prenotazione",
  r_sum__intelligent: "R somma intelligente",
  prix_base: "Prezzo base",
  total_actuel: "Totale attuale",
  inclut_1eur_voyageur___1eur_h_te_par_nuit__assuran:
    "Include 1 ospite e 1 ospite per notte assicurata",
  membres_actifs: "Membri attivi",
  note_moyenne: "Voto medio",
  d_couvrez_: "scoprire",
  points_forts: "Punti salienti",
  conseils_pratiques: "Consigli pratici",
  informations_pratiques: "Informazioni pratiche",
  meilleure_saison: "La migliore stagione",
  s_jour_moyen: "soggiorno nella media",
  langue: "Lingua",
  monnaie: "Contanti",
  fuseau_horaire: "Fuso orario",
  voir_les_logements: "Guarda gli alloggi",
  nous_contacter: "Contattaci",
  villa: "Villa",
  logements_disponibles___: "Alloggi disponibili",
  annonces___la_nuit_avec_h_tes_v_rifi_s_:
    "Annunci notturni con host verificati",
  voir_la_carte_des_logements: "Vedi la mappa degli alloggi",
  h_te_v_rifi_: "host verificato",
  mod_le_traveltrok: "Modifica il traveltrok",
  r_server: "prenotare",
  pas_encore_de_logements_ici: "Nessun alloggio qui ancora",
  sois_le_premier_h_te___proposer_son_logement___:
    "Sii il primo host a offrire il proprio alloggio",
  ajouter_mon_logement: "Aggiungi il mio alloggio",
  destinations_proches: "Destinazioni vicine",
  explorez_d_autres_destinations_en_: "Esplora altre destinazioni in",
  am_rique_du_nord: "America del Nord",
  am_rique_du_sud: "Sud America",
  oc_anie: "Oceania",
  afrique: "Africa",
  asie: "Asia",
  europe: "Europa",
  carte_des_destinations: "Mappa delle destinazioni",
  destinations_affich_es: "Destinazioni visualizzate",
  continents: "Continenti",
  survolez_un_point_pour_voir_les_d_tails:
    "Passa il mouse su un punto per visualizzare i dettagli",
  _changes_r_alis_s: "modifiche apportate",
  mes_favoris: "I miei preferiti",
  sauvegard_: "Backup",
  tout_effacer: "Cancella tutto",
  s_lectionn_: "Selezione",
  pour_comparaison: "Per confronto",
  voir_la_comparaison: "Vedi il confronto",
  trier_par__: "ordinare per",
  note: "Nota",
  _changes: "cambiamenti",
  capacit_: "Capacità",
  pi_ces: "Pezzi",
  type_de_logement: "Tipo di alloggio",
  effacer: "Cancellare",
  r_initialiser_les_filtres: "R inizializza i filtri",
  filtres_actifs__: "Filtri attivi",
  aucun_r_sultat: "Nessun risultato",
  aucun_favori_ne_correspond___vos_filtres_:
    "Nessun preferito corrisponde ai tuoi filtri",
  comparaison_des_logements: "Confronto degli alloggi",
  logements_s_lectionn_s: "Alloggi selezionati",
  fermer: "Vicino",
  astuce: "Trucco",
  utilisez_les_filtres_pour_affiner_vos_favoris_par:
    "Utilizza i filtri per perfezionare i tuoi preferiti",
  type: "Tipo",
  s_lectionnez_ensuite_jusqu______4_logements_pour_l:
    "Quindi seleziona fino a 4 slot per il",
  aucun_sch_ma_conversation_compatible_trouv__:
    "No sch, è stata trovata la mia conversazione compatibile",
  souhaite_venir_dynamique: "Desiderio di diventare dinamico",
  aimerais_visiter_dynamique: "Mi piacerebbe visitare Dynamic",
  demande_ignor_e_: "Richiesta ignorata",
  conversation_introuvable_: "Conversazione non trovata",
  impossible_d_ouvrir_la_discussion_pour_le_moment_:
    "Impossibile aprire la discussione al momento",
  demande_supprim_e_: "Richiesta eliminata",
  bonjour_merci_dynamique: "Ciao grazie dinamico",
  demande_supprim_e_avec_un_message_poli_:
    "Richiesta eliminata con un messaggio cortese",
  impossible_de_supprimer_cette_demande_pour_le_mome:
    "Impossibile eliminare questa richiesta in questo momento",
  demandes_directes: "Richieste dirette",
  matching_auto: "Vogliono venire nella tua zona",
  match_r_ciproque: "Corrispondenza reciproca",
  carte_secteur: "Carta di settore",
  toutes: "Tutto",
  lik_es: "Mi è piaciuto",
  en_discussion: "In discussione",
  ignor_es: "Ignorato",
  sans_date_pr_cise__juste__change_: "Senza data specifica basta scambiare",
  date_pr_cise___dans_les_6_mois: "Data specifica entro 6 mesi",
  date_pr_cise___dans_l_ann_e: "Data specifica dell'anno",
  flexible: "Flessibile",
  date_pr_cise: "Data specifica",
  dates_identiques: "Stesse date",
  dates_compatibles: "Date compatibili",
  dates_diff_rentes: "Date diverse",
  dates_inconnues: "Date sconosciute",
  souhaite_venir__: "Desiderio di venire",
  voir_le_logement_cibl_: "Visualizza l'alloggio di destinazione",
  personnes_int_ress_es_par_votre_secteur: "Persone interessate al tuo settore",
  vert___match_r_ciproque_ville___dates:
    "Date delle città della corrispondenza reciproca verde",
  int_r_t_entrant: "Interessi in arrivo",
  logement_cibl___: "Alloggi mirati",
  dates__: "Date",
  sans_date_pr_cise: "Senza data specifica",
  ouvrir_le_chat: "Apri la chat",
  pas_encore_de_points_sur_la_carte: "Nessun punto sulla mappa ancora",
  les_membres_qui_veulent_venir_dans_votre_secteur_a:
    "Membri che vogliono venire nella tua zona",
  logement_vis_: "Alloggio mirato",
  demande: "Richiesta",
  message: "Messaggio",
  logement_s_: "alloggio(i)",
  annonce_indisponible: "Annuncio non disponibile",
  jour_s_: "giorni)",
  dur_e___d_finir: "Durata per finire",
  match_auto: "Corrispondenza automatica",
  r_ciproque: "Reciproco",
  discuter_dans_la_messagerie: "Chatta nella messaggistica",
  ignorer_la_demande: "Ignora la richiesta",
  ignorer: "Ignorare",
  supprimer_avec_message_poli: "Elimina con un messaggio gentile",
  poli: "Educato",
  supprimer_sans_message: "Elimina senza messaggio",
  suppr_: "Eliminare",
  aucune_demande_pour_le_moment: "Nessuna richiesta al momento",
  le_tableau_est_pr_t__les_demandes_s_afficheront_ic:
    "La bacheca è pronta e le richieste appariranno qui",
  surface: "Superficie",
  voyagez: "Viaggio",
  envie_d___changer_avec_: "Vuoi cambiare con",
  proposez_un__change_de_logement_et_d_couvrez_:
    "Proporre uno scambio abitativo e una copertura",
  gratuitement_: "Gratuito",
  voir_la_fiche_du_logement: "Consulta la scheda alloggio",
  carte_des_logements: "Mappa degli alloggi",
  r_sultats_visibles: "risultati visibili",
  jour: "Giorno",
  s_lectionn_s: "selezionato s",
  printemps: "Primavera",
  _t_: "T",
  automne: "Autunno",
  hiver: "Inverno",
  toute_l__ann_e: "Tutto l'anno",
  bonjour_host_dynamic: "Ciao host dinamico",
  impossible_de_contacter_cet_h_te____errormessage__:
    "Impossibile contattare questo messaggio di errore host",
  impossible_de_contacter_cet_h_te_pour_le_moment_:
    "Impossibile contattare questo host al momento",
  annonce_introuvable_: "Annuncio non trovato",
  choisissez_vos_dates_pour_envoyer_la_proposition_:
    "Scegli le date per inviare la proposta",
  la_date_de_d_part_doit__tre_post_rieure___la_date_:
    "La data di partenza deve essere successiva alla data di arrivo",
  proposition_d__change_avec_dates_pr_cises:
    "Proposta di scambio con date specifiche",
  __logement_cibl_: "Alloggi mirati",
  __ville: "Città",
  __arriv_e_souhait_e: "Arrivo desiderato",
  __d_part_souhait_: "Partenza desiderata",
  __dur_e: "Durata",
  nuit_s_: "Notte(i)",
  __voyageurs: "Viaggiatori",
  je_suis_ouvert_e____une_n_gociation_si_besoin_:
    "Sono aperto alla trattativa se necessario.",
  indiquez_un_nombre_de_nuits_valide_pour_la_proposi:
    "Indicare un numero di notti valido per la proposta",
  proposition_d__change_flexible__sans_dates_fix_es_:
    "Proposta di scambio flessibile senza date fisse",
  __je_propose: "Propongo",
  __je_demande: "chiedo",
  on_valide_les_dates_ensemble_ensuite_selon_nos_dis:
    "Convalidiamo quindi insieme le date in base alla nostra disponibilità.",
  indiquez_un_nombre_de_nuits_valide_: "Inserisci un numero di notti valido",
  proposition_d__change__n_importe_quand_dans_l_ann_:
    "Proposta di scambio in qualsiasi momento dell'anno",
  __dur_e_souhait_e: "Durata desiderata",
  __p_riode_pr_f_r_e: "Periodo preferito",
  je_suis_flexible_sur_les_dates_exactes_et_pr_t_e__:
    "Sono flessibile sulle date precise e disposto a parlarne.",
  proposition_invalide_: "Proposta non valida",
  proposition_envoy_e__ouverture_de_la_discussion___:
    "Proposta inviata, discussione aperta...",
  impossible_d_envoyer_votre_proposition____errormes:
    "Impossibile inviare la tua proposta",
  impossible_d_envoyer_votre_proposition_pour_le_mom:
    "Impossibile inviare la tua proposta al momento",
  logement_introuvable: "Alloggio non trovato",
  retour_aux_logements: "Rientro all'alloggio",
  annonce_airbnb: "Annuncio di Airbnb",
  lien_airbnb_verification_helper:
    "Questo collegamento ci consente di verificare che sei il gestore dell'annuncio.",
  aucune_photo_disponible: "Nessuna foto disponibile",
  logement_propos__par: "Alloggio offerto da",
  __propos_de_ce_logement: "Informazioni su questo alloggio",
  aucune_description_fournie_: "Nessuna descrizione fornita",
  ce_que_propose_ce_logement: "Cosa offre questo alloggio",
  description_du_logement: "Descrizione dell'alloggio",
  aucun__quipement_sp_cifi__: "Nessuna attrezzatura specificata",
  _change_entre_h_tes: "scambio tra host",
  votre_proposition_d__change: "La tua proposta di scambio",
  quand_vous_voulez: "Quando vuoi",
  je_propose: "Propongo",
  nuits_chez_moi: "Notti a casa mia",
  je_demande: "chiedo",
  nuits_chez_vous: "Notti a casa tua",
  nombre_de_nuits: "Numero di notti",
  p_riode_pr_f_r_e: "Periodo preferito",
  message__optionnel_: "Messaggio facoltativo",
  ex__nous_sommes_flexibles__on_peut_s_adapter___vos:
    "Ex siamo flessibili, possiamo adattarci alle tue",
  entrer_en_n_gociation: "Entra in trattativa",
  envoyer_ma_proposition: "Invia la mia proposta",
  vous_pouvez_proposer_un__change_avec_ou_sans_dates:
    "Puoi offrire uno scambio con o senza date",
  informations_l_gales: "Informazioni legali",
  conditions_d____utilisation: "Termini di utilizzo",
  en_utilisant_traveltrok__vous_acceptez_d_utilise:
    "Utilizzando traveltrok accetti di utilizzare",
  les__changes_se_font_directement_entre_membres__:
    "Gli scambi vengono effettuati direttamente tra i membri",
  traveltrok_peut_suspendre_un_compte_en_cas_de_co:
    "DONKEY TRAVEL può sospendere un account in caso di co",
  en_rejoignant_traveltrok__vous_acceptez_ces_engagements__la_confiance_se_construit_sur_des_actes_simples__honn_tet___respect_et_parole_tenue_:
    "Iscrivendoti a DONKEY TRAVEL accetti questi impegni. La fiducia si basa su azioni semplici.",
  cette_charte_est_align_e_avec_les_standards_publics_des_plateformes_majeures__respect_du_logement__fiabilit___anti_f_te__communication__:
    "Una carta solida in linea con le migliori pratiche di altre famose aziende.",
  retrait_du_club_en_cas_de_manquement_grave_ou_r_p_tition_:
    "Ritiro dal club a seguito di recidiva o colpa grave.",
  exclusion_d_finitive: "Esclusione permanente",
  compte_limit__le_temps_de_v_rifier_les_faits_et_prot_ger_la_communaut__:
    "Conto ristretto in attesa dei fatti.",
  suspension_temporaire: "Sospensione temporanea",
  rappel__crit_des_r_gles__avec_demande_de_correction_imm_diate_:
    "Promemoria delle regole e correzione richiesta.",
  avertissement_officiel: "Avvertimento ufficiale",
  le_club_prot_ge_les_h_tes_fiables__les_manquements_r_p_t_s_ou_graves_entra_nent_des_mesures_imm_diates_:
    "Il club protegge gli ospiti affidabili. Le violazioni gravi comportano un'azione.",
  toute_annulation_doit__tre_document_e_dans_la_messagerie_et_trait_e_par_le_support_:
    "Qualsiasi cancellazione deve essere documentata nella messaggistica ed elaborata dal supporto.",
  on_n_annule_pas_un__change_sans_raison_valable__en_cas_de_force_majeure__sinistre__maladie_grave__impossibilit__l_gale___un_report_doit__tre_propos__au_plus_vite_:
    "Non annulliamo uno scambio senza un motivo valido. In caso di forza maggiore (catastrofe, malattia grave, impossibilità giuridica), deve essere proposto un rinvio il più rapidamente possibile.",
  je_communique_vite_en_cas_de_doute_ou_de_changement_:
    "Comunico velocemente in caso di dubbi o cambiamenti.",
  j_accueille_quelqu_un_qui_exerce_le_m_me_m_tier_d_h_te_:
    "Accolgo qualcuno che faccia lo stesso lavoro di host.",
  j_assure_un_accueil_chaleureux_et_professionnel_:
    "Offro un'accoglienza calorosa e professionale.",
  relation_entre_h_tes: "Rapporto tra host",
  les__ventuels_frais_de_m_nage_sont_annonc_s_et_valid_s_avant_s_jour_:
    "Eventuali spese di pulizia vengono annunciate e convalidate prima dello scambio.",
  les_informations_d_acc_s_et_de_fonctionnement_sont_claires_:
    "L'accesso e le informazioni operative sono chiari.",
  linge_et_pr_paration: "Lavanderia e preparazione",
  le_niveau_de_prestation_reste_identique__m_me_en__change_gratuit_:
    "Il livello di servizio rimane lo stesso, anche in caso di scambio gratuito.",
  le_logement_est_propre_et_pr_t___vivre_d_s_l_arriv_e_:
    "L'alloggio è pulito e pronto da abitare all'arrivo.",
  je_pr_pare_le_logement_comme_pour_un_client_airbnb_:
    "Preparo l'alloggio come per un cliente Airbnb.",
  qualit__d_accueil__quivalente: "Qualità di ricezione equivalente",
  je_respecte_le_calme__les_voisins_et_le_quartier_:
    "Rispetto la calma, i vicini e il vicinato.",
  aucune_f_te___v_nement_ou_invitation_non_autoris_e_dans_le_logement_:
    "Non sono ammesse feste, eventi o inviti non autorizzati nell'alloggio.",
  je_respecte_le_r_glement_int_rieur_de_l_h_te_:
    "Rispetto il regolamento interno dell'host.",
  vie_de_quartier_et_r_gles: "Vita e regole del quartiere",
  quand_des_dates_sont_bloqu_es__je_m_engage___venir_:
    "Quando le date sono bloccate, mi impegno a venire.",
  je_ne_mens_pas_sur_la_valeur_prix_habituel_de_mon_logement_:
    "Non mento sul valore abituale del mio alloggio.",
  je_ne_mens_pas_sur_ma_fiche__mon_historique_ni_mon_logement_:
    "Non mento sul mio profilo, sulla mia storia o sul mio alloggio.",
  honn_tet__et_fiabilit_: "Onestà e affidabilità",
  je_respecte_le_mat_riel__les__quipements_et_les_consignes_de_d_part_:
    "Rispetto i materiali, le attrezzature e le istruzioni di partenza.",
  je_range_le_linge_utilis___ex__draps_en_boule___l_endroit_indiqu___pour_limiter_les_frais_de_m_nage_:
    "Conservo la biancheria usata (es. lenzuola in gomitolo) nel luogo indicato, per limitare i costi di pulizia.",
  je_rends_le_logement_aussi_propre_que_je_l_ai_trouv_:
    "Rendo l'alloggio pulito come l'ho trovato.",
  respect_total_du_logement: "Rispetto totale dell'abitazione",
  traveltrok_est_un_club_d_h_tes_s_rieux__une_bonne_note_implique_une_conduite_exemplaire__en_tant_que_voyageur_comme_en_tant_qu_h_te_:
    "DONKEY TRAVEL è un host club serio; una buona valutazione implica una condotta esemplare, sia come viaggiatore che come ospitante.",
  "howItWorks.cta.explore": "Esplora le destinazioni",
  "howItWorks.cta.signup": "Guarda le nostre offerte",
  "howItWorks.cta.subtitle":
    "Inizia affittando il tuo posto. Quindi attiva scambio se vuoi scambiare tra host.",
  "howItWorks.cta.title": "Pronto a lanciare i tuoi noleggi?",
  publiez_votre_logement__validez_votre_profil_et_commencez_a_recevoir_des_propositions_d_echange_:
    "Pubblica il tuo alloggio, convalida il tuo profilo e inizia a ricevere offerte di scambio.",
  visualisez_la_densite_des_logements_deja_inscrits_dans_le_club__les_points_restent_anonymes__pas_d_adresse__pas_de_detail__juste_la_dynamique_du_reseau_:
    "Visualizza la densità degli alloggi già registrati nel club. I punti rimangono anonimi (nessun indirizzo, nessun dettaglio, solo dinamiche di rete).",
  prenez_du_recul_pour__viter_l__puisement_li___l_accueil_continu_:
    "Fai un passo indietro per evitare il burnout dovuto all'hosting continuo.",
  _an: "/ anno",
  traveltrok_connecte_les_h_tes_du_monde_entier_pour_des_s_jours_authentiques_et_abordables_:
    "DONKEY TRAVEL mette in contatto gli ospiti di tutto il mondo per soggiorni autentici e convenienti.",
  ____100__made_in_france__picardie_: "🇫🇷 100% Prodotto in Francia (Picardia)",
  pas_la_silicon_valley__mais_la_vall_e_de_la_haute_somme_:
    "Non la Silicon Valley, ma la valle dell’Alta Somme.",
  _changes_dans_toute_l_europe_entre_h_tes_airbnb_not_s_4_5___offre_lancement_2026___50__:
    "Scambi in tutta Europa tra host Airbnb con punteggio 4,5+. Offerta lancio 2026: -50%.",
  apr_s_des_mois_d_accueil__transformez_vos_p_riodes_creuses_en_vraies_respirations_sans_exploser_votre_budget_:
    "Dopo mesi di hosting, trasforma i tuoi periodi lenti in veri e propri momenti di respiro senza intaccare il tuo budget.",
  prenez_du_recul_pour__viter_l__puisement_li____l_accueil_continu_:
    "Fai un passo indietro per evitare il burnout dovuto all'hosting continuo.",
  accueillez_des_h_tes_qui_connaissent_d_j__les_exigences_du_terrain__puis_partagez_vos_m_thodes_et_vos_retours_d_exp_rience_:
    "Accogli gli ospiti che già conoscono i requisiti del settore, quindi condividi i tuoi metodi e feedback.",
  voyagez___co_t_r_duit_gr_ce_aux__changes_entre_membres_du_club_:
    "Viaggia a costi ridotti grazie agli scambi tra i soci del club.",
  quand_votre_quota_local_est_atteint__vous_pouvez__changer_hors_plateforme_sous_r_serve_de_conformit__locale_:
    "Quando viene raggiunta la quota locale, puoi fare trading fuori piattaforma in conformità alla conformità locale.",
  traveltrok_est_une_r_volution_europ_enne__une_plateforme_d__changes_pour_les_h_tes_qui_paient_d_j__chauffage__taxes__imp_ts___lectricit___internet_et_entretien__et_accueillent_toute_l_ann_e_comme___l_h_tel__ici__vous__changez_avec_des_h_tes_qui_savent_accueillir__vous_partagez_vos_exp_riences__puis_vous_partez_d_couvrir_un_autre_endroit_sans_vous_ruiner_:
    "DONKEY TRAVEL è una rivoluzione europea: una piattaforma di scambio per gli ospiti che già pagano riscaldamento, tasse, elettricità, internet e manutenzione, e sono accolti tutto l'anno come in un albergo. Qui interagisci con host che sanno come accoglierti, condividi le tue esperienze, poi vai alla scoperta di un altro posto senza spendere una fortuna.",
  ___notre_mod_le_repose_uniquement_sur_les_abonnements__pas_sur_l_exploitation_des_donn_es_:
    "👉 Il nostro modello si basa esclusivamente sugli abbonamenti, non sullo sfruttamento dei dati.",
  ___sans_publicit___sans_revente_de_donn_es__100___financ__par_les_membres_:
    "🔒 Senza pubblicità. Senza rivendita dei dati. Finanziato al 100% dai membri.",
  le_club_n_est_pas_un_conseil_juridique___chaque_membre_doit_respecter_les_r_gles_locales__d_clarations__quotas__copropri_t___fiscalit___etc___:
    "Il club non è una consulenza legale; ogni membro deve rispettare le regole locali (dichiarazioni, quote, comproprietà, tassazione, ecc.).",
  une_plateforme_d__changes_europ_enne_r_serv_e_aux_h_tes_airbnb:
    "Una piattaforma di scambio europea riservata agli host Airbnb",
  club_priv__pour_h_tes_not_s_4_5____un_abonnement_unique_pour__changer_dans_toute_l_europe_:
    "Club privato per ospiti 4,5+: un abbonamento unico per scambiare in tutta Europa.",
  r_serv__aux_h_tes_airbnb_avec_une_note_sup_rieure_ou__gale___4_5_:
    "Riservato agli host Airbnb con valutazione maggiore o uguale a 4,5.",
  r_duction_de_50__en_2026__25eur_an_au_lieu_de_50eur_an__prix_garanti___vie_pour_les_1000_premiers_inscrits_:
    "Riduzione del 50% nel 2026: 25EUR/anno invece di 50EUR/anno. Prezzo garantito a vita per le prime 1000 iscrizioni.",
  basse_saison__pause__rencontres_entre_h_tes___conomies_vacances__tout_est_pens__pour_les_h_tes_actifs_en_europe_:
    "Bassa stagione, soggiorni, incontri tra ospiti, risparmi sulle vacanze: tutto è pensato per gli ospiti attivi in ​​Europa.",
  accueillez_des_membres_et_faites_vous_accueillir_en_retour__un__change_simple__direct_et_sans_argent_entre_propri_taires_:
    "Accogli i membri e sarai il benvenuto. Uno scambio semplice, diretto e senza contanti tra proprietari.",
  _nous_avons__chang__notre_maison___lyon_contre_une_villa_en_corse__co_t___0___:
    "'\"Abbiamo scambiato la nostra casa a Lione con una villa in Corsica. Costo: 0€.\"'",
  pas_de_monnaie__pas_de_points__juste_un_accord_entre_deux_propri_taires__je_viens_chez_toi__tu_viens_chez_moi_:
    "Niente monete, niente punti. Solo un accordo tra due proprietari. Io vengo a casa tua, tu vieni a casa mia.",
  vous_trouvez_un_membre_qui_vous_pla_t_et_vous_vous_mettez_d_accord_pour__changer_vos_logements_:
    "Trovi un membro che ti piace e accetti di scambiare alloggio.",
  pas_de_points___compter__juste_le_plaisir_de_partager_et_de_se_rencontrer_:
    "Nessun punto da contare. Solo il piacere della condivisione e dell'incontro.",
  plus_qu_une__conomie__c_est_une_nouvelle_fa_on_de_voyager_:
    "Più che un'economia, è un nuovo modo di viaggiare.",
  les__changes_sont_totalement_gratuits__pas_de_frais_de_service__pas_de_frais_de_m_nage__sauf_accord_sp_cifique__:
    "Gli scambi sono completamente gratuiti. Nessun costo di servizio, nessun costo di pulizia (se non espressamente concordato).",
  seuls_les_h_tes_v_rifi_s_peuvent__changer__vous_accueillez_quelqu_un_qui_conna_t_la_valeur_d_un_logement_:
    "Solo gli host verificati possono commerciare. Stai accogliendo qualcuno che conosce il valore di una casa.",
  oubliez_la_valeur_des_points__une_nuit_est_une_nuit__l__change_est_bas__sur_la_confiance_entre_h_tes_:
    "Dimentica il valore dei punti. Una notte è una notte. Lo scambio si basa sulla fiducia tra gli host.",
  __an: "/ anno",
  _changes_dans_toute_l_europe_entre_h_tes_airbnb_no:
    "Scambi in tutta Europa tra host Airbnb con punteggio 4,5+. Offerta lancio 2026: -50%.",
  apr_s_des_mois_d_accueil__transformez_vos_p_riodes:
    "Dopo mesi di hosting, trasforma i tuoi periodi lenti in veri e propri momenti di respiro senza intaccare il tuo budget.",
  prenez_du_recul_pour__viter_l__puisement_li____l_a:
    "Fai un passo indietro per evitare il burnout dovuto all'hosting continuo.",
  accueillez_des_h_tes_qui_connaissent_d_j__les_exig:
    "Accogli gli ospiti che già conoscono i requisiti del settore, quindi condividi i tuoi metodi e feedback.",
  voyagez___co_t_r_duit_gr_ce_aux__changes_entre_mem:
    "Viaggia a costi ridotti grazie agli scambi tra i soci del club.",
  quand_votre_quota_local_est_atteint__vous_pouvez__:
    "Quando viene raggiunta la quota locale, puoi fare trading fuori piattaforma in conformità alla conformità locale.",
  la_r_volution_des_h_tes_en_europe:
    "La rivoluzione dei padroni di casa in Europa",
  enfin_une_pause_pour_les_h_tes_airbnb_not_s_4_5_:
    "Finalmente una pausa per gli host Airbnb con punteggio 4.5+",
  traveltrok_est_une_r_volution_europ_enne__une_plat:
    "DONKEY TRAVEL è una rivoluzione europea: una piattaforma di scambio per gli ospiti che già pagano riscaldamento, tasse, elettricità, internet e manutenzione, e sono accolti tutto l'anno come in un albergo. Qui interagisci con host che sanno come accoglierti, condividi le tue esperienze, poi vai alla scoperta di un altro posto senza spendere una fortuna.",
  prix_garanti___vie_pour_les_1000_premiers_inscrits:
    "Prezzo garantito a vita per le prime 1000 iscrizioni.",
  chez_traveltrok__vos_donn_es_ne_sont_pas_un_produi:
    "Per DONKEY TRAVEL i tuoi dati non sono un prodotto.",
  nous_ne_vendons_jamais_les_informations_de_nos_mem:
    "Non vendiamo mai le informazioni dei nostri membri.",
  nous_ne_partageons_aucune_donn_e_avec_des_tiers___:
    "Non condividiamo alcun dato con terze parti per scopi commerciali.",
  le_site_est_s_curis__et_vos__changes_restent_priv_:
    "Il sito è sicuro e i tuoi scambi rimangono privati.",
  traveltrok_est_garanti_sans_publicit____vous__tes_:
    "DONKEY TRAVEL è garantito senza pubblicità: tu sei il membro, non il prodotto.",
  ___notre_mod_le_repose_uniquement_sur_les_abonneme:
    "👉 Il nostro modello si basa esclusivamente sugli abbonamenti, non sullo sfruttamento dei dati.",
  ___sans_publicit___sans_revente_de_donn_es__100___:
    "🔒 Senza pubblicità. Senza rivendita dei dati. Finanziato al 100% dai membri.",
  le_club_n_est_pas_un_conseil_juridique___chaque_me:
    "Il club non è una consulenza legale; ogni membro deve rispettare le regole locali (dichiarazioni, quote, comproprietà, tassazione, ecc.).",
  une_plateforme_d__changes_europ_enne_r_serv_e_aux_:
    "Una piattaforma di scambio europea riservata agli host Airbnb",
  club_priv__pour_h_tes_not_s_4_5____un_abonnement_u:
    "Club privato per ospiti 4,5+: un abbonamento unico per scambiare in tutta Europa.",
  acc_s_r_serv_: "Accesso riservato",
  r_serv__aux_h_tes_airbnb_avec_une_note_sup_rieure_:
    "Riservato agli host Airbnb con valutazione maggiore o uguale a 4,5.",
  europe_unique: "Unica Europa",
  "50eur_an_pour__changer_dans_toute_l_europe_":
    "50EUR/anno per lo scambio in tutta Europa.",
  lancement_2026: "Lancio 2026",
  r_duction_de_50__en_2026__25eur_an_au_lieu_de_50eu:
    "Riduzione del 50% nel 2026: 25EUR/anno invece di 50EUR/anno. Prezzo garantito a vita per le prime 1000 iscrizioni.",
  club_d__change_h_tes_airbnb: "Club di scambio host di Airbnb",
  optimisez_vos_p_riodes_creuses_gr_ce_aux__changes:
    "Ottimizza i tuoi periodi non di punta grazie agli scambi",
  basse_saison__pause__rencontres_entre_h_tes___cono:
    "Bassa stagione, soggiorni, incontri tra ospiti, risparmi sulle vacanze: tutto è pensato per gli ospiti attivi in ​​Europa.",
  r_serv__aux_h_tes_traveltrok: "Riservato agli ospiti DONKEY TRAVEL",
  voyagez_gratuitement_gr_ce___votre_logement:
    "Viaggia gratis con il tuo alloggio",
  accueillez_des_membres_et_faites_vous_accueillir_e:
    "Accogli i membri e sarai il benvenuto. Uno scambio semplice, diretto e senza contanti tra proprietari.",
  devenir_h_te: "Diventa un ospite",
  comment__a_marche__: "Come funziona?",
  _nous_avons__chang__notre_maison___lyon_contre_une:
    "'\"Abbiamo scambiato la nostra casa a Lione con una villa in Corsica. Costo: 0€.\"'",
  amis_partageant_un_repas_en_corse:
    "Amici che condividono un pasto in Corsica",
  sophie___marc__membres_depuis_2023: "Sophie & Marc, membri dal 2023",
  pas_besoin_d__changer_aux_m_mes_dates____tu_viens:
    "Non c'è bisogno di scambiare nelle stesse date: tu vieni a casa mia a giugno, io vengo a casa tua a settembre!",
  l__change_direct___simple_et_humain: "Lo scambio diretto: semplice e umano",
  pas_de_monnaie__pas_de_points__juste_un_accord_ent:
    "Niente monete, niente punti. Solo un accordo tra due proprietari. Io vengo a casa tua, tu vieni a casa mia.",
  "1__accord_mutuel": "1. Accordo reciproco",
  vous_trouvez_un_membre_qui_vous_pla_t_et_vous_vous:
    "Trovi un membro che ti piace e accetti di scambiare alloggio.",
  "2__flexibilit__totale": "2. Flessibilità totale",
  "3__z_ro_comptabilit_": "3. Contabilità zero",
  pas_de_points___compter__juste_le_plaisir_de_parta:
    "Nessun punto da contare. Solo il piacere della condivisione e dell'incontro.",
  pourquoi_les_h_tes_adorent_ce_syst_me__:
    "Perché gli host adorano questo sistema?",
  plus_qu_une__conomie__c_est_une_nouvelle_fa_on_de_:
    "Più che un'economia, è un nuovo modo di viaggiare.",
  "0__de_frais": "0€ commissioni",
  les__changes_sont_totalement_gratuits__pas_de_frai:
    "Gli scambi sono completamente gratuiti. Nessun costo di servizio, nessun costo di pulizia (se non espressamente concordato).",
  confiance_totale: "Fiducia totale",
  seuls_les_h_tes_v_rifi_s_peuvent__changer__vous_ac:
    "Solo gli host verificati possono commerciare. Stai accogliendo qualcuno che conosce il valore di una casa.",
  simplicit_: "Semplicità",
  oubliez_la_valeur_des_points__une_nuit_est_une_nui:
    "Dimentica il valore dei punti. Una notte è una notte. Lo scambio si basa sulla fiducia tra gli host.",
  rejoignez_la_communaut__des_h_tes: "Unisciti alla comunità ospitante",
  rejoignez_la_communaut__et_commencez____changer_:
    "Unisciti alla community e inizia a chattare.",
  commencer_maintenant: "Inizia ora",
  chargement___: "Caricamento...",
  accueil: "Benvenuto",
  comment_a_marche: "Come funziona",
  vos_engagements: "I tuoi impegni",
  pays: "Paese",
  logements: "Alloggiamento",
  _change_h_te: "Scambio di host",
  devenir_membre: "Diventa un membro",
  se_d_connecter: "Esci",
  mon_espace: "Il mio spazio",
  connexion: "Connessione",
  connect_: "Collegato",
  visuel_en_cours_de_g_n_ration_ai___: "Visualizzazione generata dall'IA...",
  tableau_de_bord: "Pannello di controllo",
  mes_annonces: "I miei annunci",
  o__je_veux_aller: "Dove voglio andare",
  qui_veut_venir_chez_moi: "Abbinamento intelligente",
  destinations: "Destinazioni",
  carte_des_membres: "Tessera soci",
  calendrier: "Calendario",
  votre_coffre: "Sei al sicuro",
  favoris: "Preferiti",
  messages: "Messaggi",
  mon_profil: "Il mio profilo",
  pr_f_rences: "Preferenze",
  profil: "Profilo",
  h_te: "Ospite",
  membre_fondateur: "Membro Fondatore",
  membre: "Membro",
  r_duire__tendre: "Ridurre/espandere",
  r_duire_le_menu: "Comprimi il menu",
  cette_page_n_a_pas__t__g_n_r_e: "Questa pagina non è stata generata",
  donne_moi_plus_de_d_tails_sur_cette_page_pour_que_je_puisse_la_g_n_rer:
    "Dammi maggiori dettagli su questa pagina così posso generarla",
  connexion_en_cours___: "Connessione in corso...",
  email_ou_mot_de_passe_incorrect: "E-mail o password errati",
  une_erreur_est_survenue: "Si è verificato un errore",
  erreur_de_connexion_google: "Errore di connessione a Google",
  connecte_toi_pour_retrouver_ta_communaut_:
    "Accedi per trovare la tua comunità",
  rejoins_la_communaut__des_h_tes_traveltrok:
    "Unisciti alla comunità ospitante di DONKEY TRAVEL",
  inscription: "Registrazione",
  continuer_avec_google: "Continua con Google",
  ou: "O",
  ton_pr_nom_et_nom: "Il tuo nome e cognome",
  jean_h_mar: "Jean Hemar",
  lien_annonce_airbnb: "Link al tuo annuncio Airbnb",
  veuillez_saisir_un_lien_airbnb_valide:
    "Fornisci un collegamento Airbnb valido",
  lien_calendrier_ical:
    "Collegamento iCal al tuo calendario Airbnb (facoltativo per ora)",
  lien_ical_explication_lecture_seule:
    "Donkey Travel non cambia mai il tuo calendario Airbnb. L'abbiamo letto solo per mostrare la tua disponibilità. Dovrai continuare a bloccare manualmente le date di riscatto su Airbnb per evitare doppie prenotazioni.",
  note_airbnb: "Valutazione di Airbnb",
  abonnement: "Sottoscrizione",
  europe_unique___50eur_an: "Unica Europa - 50EUR/anno",
  offre_lancement_2026__25eur_an___50__:
    "Offerta lancio 2026: 25EUR/anno (-50%)",
  prix_garanti___vie_pour_les_1000_premiers_inscrits_:
    "Prezzo garantito a vita per le prime 1000 iscrizioni.",
  mot_de_passe: "Password",
  "8_caract_res_minimum": "Minimo 8 caratteri",
  connexion___: "Connessione...",
  cr_ation_du_compte___: "Creazione dell'account...",
  se_connecter: "Login",
  cr_er_mon_compte: "Crea il mio account",
  mot_de_passe_oubli___: "Password dimenticata?",
  en_cr_ant_un_compte__tu_acceptes_nos_:
    "Creando un account, accetti il ​​nostro",
  cgu: "CGU",
  _et_notre_: "e il nostro",
  politique_de_confidentialit_: "politica sulla riservatezza",
  r_servation_de_logements: "Prenotazione dell'alloggio",
  support_h_te_prioritaire: "Supporto host prioritario",
  carte___filtres_avanc_s: "Mappa + filtri avanzati",
  flux_de_r_servation__tape_par__tape:
    "Flusso di prenotazione passo dopo passo",
  couverture_dommages_assistance: "Copertura danni/assistenza",
  multi_logements___reporting: "Multi-housing + reporting",
  comparatif_des_modes: "Confronto di modalità",
  ce_que_tu_actives_selon_ton_usage_traveltrok_:
    "Cosa attivi in ​​base al tuo utilizzo di TRAVELTROK.",
  fonction: "Funzione",
  voyageur: "Viaggiatore",
  pro: "Pro",
  abonnement_europe_unique: "Abbonamento Europa Unica",
  rejoindre_le_club_europe: "Unisciti al club europeo",
  basse_saison: "Bassa stagione",
  pause: "Prenditi una pausa",
  rencontres: "Incontra gli host",
  _conomies: "Risparmio",
  quota_atteint: "Quota raggiunta",
  _ligibilit_: "Idoneità",
  zone_d__change: "Zona cambio",
  toute_l_europe: "Tutta l'Europa",
  mod_le: "Modello",
  abonnement_unique_annuel: "Abbonamento annuale unico",
  propri_taire_europ_en_en_pause: "Proprietario europeo in pausa",
  v_rification: "Verifica",
  h_tes_certifi_s: "Host certificati",
  abonnement_unique_traveltrok: "Abbonamento unico DONKEY TRAVEL",
  offre_lancement_2026__25eur_an_au_lieu_de_50eur_an:
    "Offerta di lancio 2026: 25EUR/anno invece di 50EUR/anno",
  pourquoi_ce_club_fonctionne_pour_les_h_tes:
    "Perché questo club lavora per gli host",
  chez_traveltrok__vos_donn_es_ne_sont_pas_un_produit_:
    "Per DONKEY TRAVEL i tuoi dati non sono un prodotto.",
  nous_ne_vendons_jamais_les_informations_de_nos_membres_:
    "Non vendiamo mai le informazioni dei nostri membri.",
  nous_ne_partageons_aucune_donn_e_avec_des_tiers___des_fins_commerciales_:
    "Non condividiamo alcun dato con terze parti per scopi commerciali.",
  le_site_est_s_curis__et_vos__changes_restent_priv_s_:
    "Il sito è sicuro e i tuoi scambi rimangono privati.",
  traveltrok_est_garanti_sans_publicit____vous__tes_le_membre__pas_le_produit_:
    "DONKEY TRAVEL è garantito senza pubblicità: tu sei il membro, non il prodotto.",
  rejoindre_le_club: "Unisciti al club",
  trouver_un_h_te: "Trova un ospite",
  proposer_un__change: "Proponi uno scambio",
  synchronisation_mise___jour_avec_succ_s:
    "Sincronizzazione aggiornata correttamente",
  erreur_lors_de_la_mise___jour: "Errore durante l'aggiornamento",
  indisponible: "Non disponibile",
  r_serv_: "Prenotare",
  erreur_chargement: "Errore di caricamento",
  inconnue: "Sconosciuto",
  impossible_de_r_cup_rer_le_calendrier_ical__v_rifiez_l_url_ical_airbnb_et_r_essayez_:
    "Impossibile recuperare il calendario iCal. Controlla l'URL iCal Airbnb e riprova.",
  r_servation: "Prenotazione",
  _v_nements_synchronis_s: "eventi sincronizzati",
  _v_nements_import_s: "eventi importati",
  erreur_sync: "Errore di sincronizzazione",
  _chec_de_synchronisation: "Errore di sincronizzazione",
  dates_bloqu_es_avec_succ_s: "Date bloccate con successo",
  erreur_blocage: "Errore di blocco",
  mois: "Mese",
  aujourd_hui: "Oggi",
  d_tails: "Dettagli",
  actions: "Azioni",
  bloquer: "Per bloccare",
  filtres: "Filtri",
  confirm_: "Confermato",
  en_attente: "In attesa",
  proposition: "Proposta",
  bloqu_: "Bloccato",
  synchronisation: "Sincronizzazione",
  configurer: "Configura",
  airbnb_connect_: "Airbnb connesso",
  derni_re_synchro_r_ussie: "Ultima sincronizzazione riuscita",
  derni_re_synchro_en__chec: "Ultima sincronizzazione non riuscita",
  calendrier_connect___lancez_une_synchro_pour_importer_vos_r_servations_airbnb_:
    "Calendario connesso. Avvia una sincronizzazione per importare le tue prenotazioni Airbnb.",
  synchro___: "Sincronizza...",
  forcer_la_synchro: "Forza la sincronizzazione",
  non_synchronis_: "Non sincronizzato",
  connectez_votre_calendrier_airbnb_pour__viter_les_doubles_r_servations__:
    "Collega il tuo calendario Airbnb per evitare doppie prenotazioni!",
  bloquer_des_dates: "Blocca le date",
  s_lection: "Selezione",
  jours: "giorni",
  raison__optionnel__ex__travaux_: "Motivazione (facoltativa, es.: Lavori)",
  annuler: "Cancellare",
  confirmer: "Confermare",
  synchronisation_airbnb: "Sincronizzazione di Airbnb",
  ajoutez_vos_liens_airbnb_pour_synchroniser_automatiquement_vos_r_servations_et__viter_les_doublons_:
    "Aggiungi i tuoi link Airbnb per sincronizzare automaticamente le tue prenotazioni ed evitare duplicati.",
  lien_de_l_annonce_airbnb: "Collegamento all'annuncio di Airbnb",
  airbnb_ical_calendar_link: "Collegamento al calendario iCal di Airbnb",
  disponible_dans_param_tres_de_l_annonce_export_du_calendrier:
    "Disponibile in Impostazioni annunci Esportazione calendario",
  enregistrer: "Salva",
  veuillez_cliquer_sur__localiser__pour_valider_l_adresse_avant_de_continuer_:
    'Fare clic su "Trova" per convalidare l\'indirizzo prima di continuare.',
  vous_devez__tre_connect__pour_publier_: "Devi essere loggato per postare.",
  id_manquant_apr_s_sauvegarde: "ID mancante dopo il backup",
  erreur_upload_photo: "Errore nel caricamento della foto",
  erreur_sauvegarde_metadata_photos:
    "Errore durante il salvataggio delle foto dei metadati",
  une_erreur_est_survenue_lors_de_la_sauvegarde:
    "Si è verificato un errore durante il salvataggio",
  quitter: "Andarsene",
  modification: "Modificare",
  cr_ation: "Creazione",
  _tape: "Palcoscenico",
  sur: "SU",
  sauvegarde_en_cours___: "Backup in corso...",
  retour: "Indietro",
  sauvegarde___: "Backup...",
  mettre___jour: "Per aggiornare",
  publier_l_annonce: "Pubblica l'annuncio",
  suivant: "Seguente",
  _tes_vous_s_r_de_vouloir_supprimer_cette_annonce__:
    "Sei sicuro di voler rimuovere questo annuncio?",
  impossible_de_supprimer_l_annonce__: "Impossibile eliminare l'annuncio:",
  g_rez_vos_logements_et_leur_disponibilit__:
    "Gestisci i tuoi alloggi e la loro disponibilità.",
  ajouter_une_annonce: "Aggiungi un annuncio",
  vous_n_avez_aucune_annonce: "Non hai annunci",
  commencez___gagner_un_revenu_en_louant_votre_logement__c_est_simple_et_rapide_:
    "Inizia a guadagnare affittando la tua casa. È facile e veloce.",
  cr_er_ma_premi_re_annonce: "Crea il mio primo annuncio",
  publi_: "Pubblicato",
  brouillon: "Bozza",
  __nuit: "/ notte",
  voir_l_annonce: "Vedi l'annuncio",
  modifier: "Per modificare",
  supprimer: "ELIMINARE",
  quels__quipements_proposez_vous__: "Che attrezzatura offrite?",
  s_lectionnez_tout_ce_qui_est_disponible_pour_les_voyageurs_:
    "Seleziona tutto ciò che è a disposizione dei viaggiatori.",
  aucun_sch_ma_conversation_compatible_trouv_:
    "Nessun diagramma di conversazione compatibile trovato.",
  logements_concern_s: "alloggi interessati",
  logement_non_pr_cis_: "Alloggio non specificato",
  erreur_lors_de_l_envoi_du_message_: "Errore durante l'invio del messaggio.",
  rechercher_une_conversation: "Cerca una conversazione",
  demandes_re_ues: "Richieste ricevute",
  mes_demandes: "Le mie richieste",
  aucune_demande_re_ue_: "Nessuna richiesta ricevuta.",
  aucune_demande_envoy_e_: "Nessuna richiesta inviata.",
  photo_de_profil: "Immagine del profilo",
  localisation_non_pr_cis_e: "Posizione non specificata",
  listing_: "Elenco:",
  en_ligne: "In linea",
  vous: "VOI",
  _crivez_votre_message___: "Scrivi il tuo messaggio...",
  s_lectionnez_une_conversation: "Seleziona una conversazione",
  pour_commencer___changer: "per iniziare a fare trading",
  logement_propos_: "Sistemazione proposta",
  description_non_pr_cis_e: "Descrizione non specificata",
  ch_: "cap.",
  voy_: "Vedere.",
  nuit: "notte",
  prix_non_pr_cis_: "Prezzo non specificato",
  voir: "Vedere",
  aucune_annonce_li_e___cette_conversation_:
    "Nessun annuncio relativo a questa conversazione.",
  s_lectionnez_une_conversation_pour_voir_les_d_tails_:
    "Seleziona una conversazione per vedere i dettagli.",
  bonjour: "Buongiorno",
  voici_ce_qui_se_passe_sur_votre_compte_aujourd_hui_:
    "Ecco cosa succede oggi nel tuo account.",
  annonces_en_ligne: "Annunci in linea",
  nouveaux_messages: "Nuovi post",
  prochains__changes: "Prossimi scambi",
  matching_section__o__je_veux_aller:
    "Sezione corrispondente: Dove voglio andare",
  ajoutez_jusqu__10_villes_avec_rayon_en_km_et_vos_dates_de_d_part_pour_recevoir_des_propositions_mieux_cibl_es_:
    "Aggiungi fino a 10 città con raggio in km e le tue date di partenza per ricevere proposte più mirate.",
  configurer_mes_pr_f_rences: "Configura le mie preferenze",
  pr_t___recevoir_vos_premiers_voyageurs__:
    "Pronti ad accogliere i vostri primi viaggiatori?",
  compl_tez_votre_profil_et_publiez_votre_premi_re_annonce_pour_commencer_____changer_votre_logement_avec_la_communaut__traveltrok_:
    "Completa il tuo profilo e pubblica il tuo primo annuncio per iniziare a scambiare il tuo alloggio con la community TravelScambio.",
  cr_er_mon_annonce: "Crea il mio annuncio",
  compl_ter_mon_profil: "Completa il mio profilo",
  impossible_de_charger_vos_preferences_:
    "Impossibile caricare le tue preferenze.",
  preferences_enregistrees_: "Preferenze salvate.",
  impossible_d_enregistrer_vos_preferences_:
    "Impossibile salvare le tue preferenze.",
  impossible_de_supprimer_votre_profil_:
    "Impossibile eliminare il tuo profilo.",
  chargement_des_preferences___: "Caricamento preferenze...",
  unites_de_distance: "Unità di distanza",
  kilom_tres__km_: "Chilometri (km)",
  format_europeen_par_defaut: "Formato europeo predefinito",
  miles__mi_: "Miglia (mi)",
  format_anglo_saxon: "Formato anglosassone",
  visibilite_du_profil: "Visibilità del profilo",
  mettre_mon_profil_en_pause: "Metti in pausa il mio profilo",
  me_masquer_dans_les_resultats_de_recherche:
    "Nascondimi dai risultati di ricerca",
  zone_sensible: "Zona sensibile",
  suppression___: "Eliminazione...",
  supprimer_mon_profil: "Elimina il mio profilo",
  pensez_a_enregistrer_vos_modifications_: "Ricordati di salvare le modifiche.",
  enregistrement___: "Registrazione...",
  enregistrer_les_preferences: "Salva le preferenze",
  impossible_de_charger_votre_profil_: "Impossibile caricare il tuo profilo.",
  profil_enregistr__partiellement__la_base_de_donn_es_doit__tre_mise___jour__migration_sql__:
    "Profilo parzialmente salvato. Il database deve essere aggiornato (migrazione SQL).",
  profil_mis___jour_avec_succ_s_: "Profilo aggiornato con successo.",
  profil_non_enregistr___la_base_de_donn_es_doit__tre_migr_e__colonnes_manquantes__:
    "Profilo non salvato: il database deve essere migrato (colonne mancanti).",
  profil_non_enregistr___trop_de_colonnes_manquantes__lancez_la_migration_sql_:
    "Profilo non salvato: mancano troppe colonne. Avvia la migrazione SQL.",
  votre_base_de_donn_es_n_est_pas___jour__lancez_la_migration_sql_puis_r_essayez_:
    "Il tuo database non è aggiornato. Esegui la migrazione SQL e riprova.",
  erreur_lors_de_la_mise___jour_: "Errore durante l'aggiornamento.",
  photo_de_profil_mise___jour_: "Foto del profilo aggiornata.",
  erreur_upload_photo_: "Errore nel caricamento della foto.",
  photo_de_couverture_mise___jour_: "Foto di copertina aggiornata.",
  erreur_upload_couverture_: "Errore nel caricamento della copertina.",
  document_envoy__pour_v_rification_: "Documento inviato per la verifica.",
  erreur_lors_de_l_envoi_du_document_: "Errore nell'invio del documento.",
  impossible_de_charger_votre_profil_pour_le_moment_:
    "Impossibile caricare il tuo profilo in questo momento.",
  mon_profil_h_te: "Il mio profilo ospite",
  identit___r_seaux_et_infos_de_matching:
    "Identità, reti e informazioni di abbinamento",
  plus_votre_profil_est_complet__plus_le_moteur_peut_proposer_des_h_tes_compatibles_:
    "Più completo è il tuo profilo, più host compatibili il motore può suggerire.",
  compl_tude_du_profil: "Completezza del profilo",
  couverture: "Coperta",
  photo_principale: "Foto principale",
  h_te_traveltrok: "Ospite VIAGGIO D'ASINO",
  localisation_non_renseign_e: "Posizione non fornita",
  ajoutez_une_photo_large_pour_mieux_pr_senter_votre_univers_d_h_te_:
    "Aggiungi una foto grande per presentare meglio il mondo che ti ospita.",
  destinations_cibl_es: "Destinazioni mirate",
  dates_pr_vues: "Date previste",
  configurer___o__je_veux_aller__: "Configura “Dove voglio andare”",
  statut_identit_: "Stato dell'identità",
  v_rifi_: "Verificato",
  en_cours: "In corso",
  non_v_rifi_: "Non verificato",
  ajoutez_une_pi_ce_d_identit__pour_renforcer_la_confiance_de_la_communaut__:
    "Aggiungi un ID per creare fiducia nella comunità.",
  envoyer_document: "Invia documento",
  identit__et_contact: "Identità e contatto",
  pr_nom: "Nome",
  nom: "Nome",
  pseudo_public: "Soprannome pubblico",
  email: "E-mail",
  t_l_phone: "Telefono",
  r_seaux_et_liens: "Reti e collegamenti",
  site_web: "Sito web",
  localisation_et_mode_de_voyage: "Posizione e modalità di viaggio",
  pays_de_r_sidence: "Paese di residenza",
  s_lectionnez_un_pays: "Seleziona un paese",
  ville_de_r_sidence: "Città di residenza",
  amiens: "Amiens",
  combien_de_personnes_voyagent__: "Quante persone viaggiano?",
  voyagez_vous_avec_des_animaux__: "Viaggi con animali?",
  oui: "SÌ",
  non: "NO",
  voyagez_vous_avec_des_b_b_s__: "Viaggi con bambini?",
  bio_h_te: "Biografia dell'ospite",
  pr_sentez_votre_style_d_accueil_et_votre_logement_:
    "Presenta il tuo stile di ospitalità e il tuo alloggio.",
  pr_sentation_de_la_famille: "Presentazione della famiglia",
  qui_voyage__habitudes__rythme__type_de_s_jour_recherch___:
    "Chi viaggia, abitudini, ritmi, tipologia di soggiorno cercato...",
  compl_tez_aussi___o__je_veux_aller___pour_activer_un_matching_plus_pr_cis_:
    "Completa anche “Dove voglio andare” per attivare abbinamenti più precisi.",
  enregistrer_le_profil: "Salva profilo",
  horizon_contrat: "Orizzonte contrattuale",
  "24_mois_apres_le_1er_sejour": "24 mesi dopo il primo soggiorno",
  nuits_que_je_dois: "Notti che devo",
  nuits_qu_on_me_doit: "Notti che devo",
  echanges_ouverts: "Scambi aperti",
  echanges_proches_echeance: "Operazioni prossime alla scadenza",
  alerte_solde_des_echanges: "Avviso saldo cambio",
  aucun_profil_a_risque_detecte_pour_le_moment_:
    "Nessun profilo di rischio rilevato al momento.",
  contrats_en_cours: "Contratti attuali",
  personne: "Persona",
  logement: "Alloggio",
  contrat: "CONTRARRE",
  dates: "Date",
  echange_effectue: "Scambio effettuato",
  solde_nuits: "Serate di saldi",
  temps_restant: "Tempo rimanente",
  "1er_sejour_": "1° soggiorno:",
  echeance_: "Scadenza:",
  ils_sont_venus__fait: "Sono venuti: fatto",
  ils_sont_venus__en_attente: "Sono venuti: aspettando",
  je_suis_alle__fait: "Sono andato: fatto",
  je_suis_alle__en_attente: "Sono andato: aspettando",
  je_dois: "Devo",
  nuits: "notti",
  on_me_doit: "Sono in debito",
  carte_des_p_rim_tres_de_recherche: "Mappa delle aree di ricerca",
  villes_localis_es: "città localizzate",
  mise___jour_de_la_carte___: "Aggiornamento della mappa...",
  vous_devez__tre_connect__pour_g_rer_vos_pr_f_rences_:
    "Devi essere loggato per gestire le tue preferenze.",
  impossible_de_charger_vos_pr_f_rences_de_matching_pour_le_moment_:
    "Impossibile caricare le tue preferenze di corrispondenza in questo momento.",
  ajoutez_au_moins_une_ville_cible_pour_activer_le_matching_:
    "Aggiungi almeno una città di destinazione per attivare la corrispondenza.",
  une_p_riode_a_une_date_de_fin_ant_rieure___la_date_de_d_part_:
    "Un periodo ha una data di fine precedente alla data di inizio.",
  s_lectionnez_au_moins_un_pays_si_vous_activez_le_filtre_de_contact_par_pays_:
    "Seleziona almeno un paese se abiliti il ​​filtro dei contatti per paese.",
  pr_f_rences_enregistr_es__les_pays_cibl_s_sont_conserv_s_localement_tant_que_la_migration_sql_n_est_pas_appliqu_e_:
    "Preferenze salvate. I paesi di destinazione vengono mantenuti localmente fino all'applicazione della migrazione SQL.",
  pr_f_rences_de_matching_enregistr_es_avec_succ_s_:
    "Preferenze corrispondenti salvate correttamente.",
  pr_f_rences_non_enregistr_es__base_non_migr_e__lancez_la_migration_sql_:
    "Preferenze non salvate: database non migrato. Avvia la migrazione SQL.",
  erreur_lors_de_l_enregistrement_: "Errore durante il salvataggio.",
  matching_intelligent: "Abbinamento intelligente",
  indiquez_vos_villes_cibles_et_vos_p_riodes_de_d_part__traveltrok_pourra_proposer_les_h_tes_les_plus_compatibles_:
    "Indica le tue città di destinazione e i tuoi periodi di partenza: DONKEY TRAVEL sarà in grado di offrirti gli host più compatibili.",
  retour_au_profil: "Torna al profilo",
  villes_et_rayon_de_recherche: "Città e raggio di ricerca",
  jusqu___10_villes__ex__amiens_2_km__paris_5_km__lille_20_km__:
    "Fino a 10 città (es: Amiens 2 km, Parigi 5 km, Lille 20 km).",
  villes_actives: "città attive",
  ville: "Città",
  choisir_un_pays: "Scegli un paese",
  saisissez_une_ville: "Inserisci una città",
  choisissez_le_pays_d_abord: "Scegli prima il paese",
  rayon: "Raggio",
  supprimer_cette_ville: "Elimina questa città",
  ajouter_une_ville: "Aggiungi una città",
  ces_villes_seront_utilis_es_pour_proposer_des_changes_cibl_s_:
    "Queste città verranno utilizzate per offrire scambi mirati.",
  enregistrer_mes_pr_f_rences: "Salva le mie preferenze",
  pays_d_europe___visiter: "Paesi europei da visitare",
  cochez_les_pays_qui_vous_int_ressent__vous_pouvez_ensuite_limiter_les_prises_de_contact___ces_pays_:
    "Controlla i paesi che ti interessano. È quindi possibile limitare i contatti a questi paesi.",
  pays_s_lectionn_s: "paesi selezionati",
  tout_cocher: "Controlla tutto",
  tout_d_cocher: "Deseleziona tutto",
  _tre_contact__uniquement_par_les_membres_de_ces_pays:
    "Fatti contattare solo da membri di questi paesi",
  ce_filtre_sera_utilis__dans_votre_matching_automatique_:
    "Questo filtro verrà utilizzato nella corrispondenza automatica.",
  union_europ_enne: "Unione Europea",
  hors_union_europ_enne: "Fuori dall’Unione Europea",
  agenda_des_d_parts_souhait_s: "Orario delle partenze desiderate",
  ajoutez_les_p_riodes_o__vous_souhaitez_partir_pour_lancer_un_matching_sur_des_cr_neaux_communs_:
    "Aggiungi i periodi in cui vuoi partire per iniziare ad abbinare sugli slot comuni.",
  p_riode_s__active_s_: "periodo/i attivo/i",
  aucune_p_riode_ajout_e_pour_le_moment_: "Nessun periodo ancora aggiunto.",
  p_riode: "Periodo",
  supprimer_cette_p_riode: "Elimina questo periodo",
  d_part: "Partenza",
  commentaire__optionnel_: "Commento (facoltativo)",
  ajouter_une_p_riode: "Aggiungi un punto",
  r_sum__matching: "Corrispondenza riepilogativa",
  villes_cibles: "Targeting delle città",
  rayon_moyen: "Raggio medio",
  p_riodes_planifi_es: "Periodi pianificati",
  pays_cibl_s: "Paesi presi di mira",
  contacts_limit_s_aux_pays_coch_s: "Contatti limitati ai paesi selezionati",
  contacts_ouverts___tous_les_pays: "Contatti aperti a tutti i paesi",
  agenda_aper_u: "Panoramica dell'agenda",
  ajoutez_une_p_riode_pour_afficher_votre_agenda_de_d_part_:
    "Aggiungi un periodo per visualizzare il calendario delle partenze.",
  sans_commentaire: "No comment",
  logement_traveltrok: "Sistemazione DONKEY VIAGGI",
  localisation_a_preciser: "Località da specificare",
  logements_trouves: "alloggio trovato",
  plus_recents: "Più recente",
  capacite_max: "Capacità massima",
  h_tes: "Ospiti",
  villes: "Città",
  logements_disponibles: "Alloggi disponibili",
  pays_disponibles: "Paesi disponibili",
  marie_accepte__: "Maria accetta!",
  nuits_a_reims_contre: "notti a Reims contro",
  nuits_a_paris: "notti a Parigi",
  l_histoire_de_marie_jean: "La storia di Marie e Jean",
  "1__marie_consulte_l_agenda_de_jean": "1. Marie consulta il diario di Jean",
  elle_voit_que_jean_a_des_dates_libres_dans_2_semaines__parfait_pour_elle___jean_confirme_qu_il_peut_liberer_ces_dates_:
    "Vede che Jean ha degli appuntamenti liberi tra 2 settimane. Perfetto per lei! Jean conferma che può rilasciare queste date.",
  h_tes_actifs: "Ospiti attivi",
  pays_couverts: "Paesi coperti",
  echanges_realises: "Scambi effettuati",
  "100__match": "Corrispondenza al 100%.",
  echanges_longue_distance: "Scambi a lunga distanza",
  matching_algorithmique_intelligent: "Corrispondenza algoritmica intelligente",
  notre_algorithme_croise_les_informations_de_votre_profil_et_de_vos_recherches_pour_vous_proposer_toutes_les_annonces_de_logements_qui_correspondent_exactement_a_votre_demande_:
    "Il nostro algoritmo incrocia le informazioni del tuo profilo e delle tue ricerche per proporti tutti gli annunci immobiliari che corrispondono esattamente alla tua richiesta.",
  matching_precis: "Abbinamento preciso",
  analyse_intelligente_de_vos_crit_res:
    "Analisi intelligente dei vostri criteri",
  gain_de_temps_dans_vos_recherches: "Risparmia tempo nella tua ricerca",
  propositions_ultra_pertinentes: "Proposte ultra-rilevanti",
  habitants: "residenti",
  destinations_europeennes: "Destinazioni europee",
  decouvrez_les_merveilles_du_continent: "Scopri le meraviglie del continente",
  pays_actifs_sur_traveltrok: "Paesi attivi su DONKEY TRAVEL",
  selectionner_un_pays: "Seleziona un paese",
  union_europeenne: "Unione Europea",
  hors_union_europeenne: "Fuori dall’Unione Europea",
  fiche_detaillee: "Scheda dettagliata",
  selectionnez_un_pays_dans_la_liste_ou_sur_la_carte_pour_decouvrir_climat__population_et_lieux_emblematiques_:
    "Seleziona un paese dall'elenco o sulla mappa per scoprire clima, popolazione e luoghi emblematici.",
  logements_actifs: "edilizia attiva",
  climat: "Clima",
  information_touristique: "Informazioni turistiche",
  lieux_emblematiques: "Luoghi iconici",
  gastronomie: "Gastronomia",
  dom_tom___outre_mer: "DOM-TOM / Estero",
  villes_principales: "Principali città",
  charte_officielle: "Carta ufficiale",
  confiance_mutuelle: "Fiducia reciproca",
  r_gles_claires: "Regole chiare",
  sanctions_applicables: "Sanzioni applicabili",
  illustration_3d_des_engagements: "Illustrazione 3D degli impegni",
  concept_3d_informations: "Immagine 3D dei dettagli",
  principe_1: "Principio 1",
  v_racit__des_informations: "Veridicità delle informazioni",
  profil__logement__photos_et_prix_doivent__tre_exacts_:
    "Profilo, alloggio, foto e prezzi devono essere accurati.",
  concept_3d_respect_du_lieu: "Immagine 3D di rispetto per il luogo",
  principe_2: "Principio 2",
  respect_du_lieu: "Rispetto per il luogo",
  aucune_f_te_et_z_ro_nuisance_pour_le_voisinage_:
    "Nessuna festa e zero fastidi per il quartiere.",
  concept_3d_fiabilit__contractuelle: "Concetto di contratto in 3D",
  principe_3: "Principio 3",
  fiabilit__contractuelle: "Affidabilità contrattuale",
  dates_bloqu_es___engagement_ferme__sauf_raison_valable_:
    "Date bloccate = impegno fermo, a meno che non vi sia un motivo valido.",
  engagements_c_t__voyageur: "Impegni dal lato passeggero",
  engagements_c_t__h_te: "Impegni lato host",
  annulations_et_reports: "Cancellazioni e rinvii",
  r_gle_op_rationnelle: "Regola operativa",
  check_list_d_part_voyageur: "Lista di controllo della partenza",
  cuisine_et_vaisselle_propres: "Cucina e stoviglie pulite",
  sols_et_surfaces_rendus_propres: "Pavimenti e superfici resi puliti",
  linge_utilis__d_pos__selon_consigne:
    "Biancheria usata depositata secondo le istruzioni",
  aucune_invitation_non_autoris_e_pendant_le_s_jour:
    "Nessun invito non autorizzato",
  _tat_final_du_logement_confirm__avec_photos:
    "Confermate le condizioni finali dell'abitazione",
  sanctions_en_cas_de_manquement: "Sanzioni in caso di inosservanza",
  ce_que_permet_traveltrok: "Cosa permette DONKEY TRAVEL",
  vous_pouvez_inscrire_autant_de_logements_que_vous_voulez_:
    "Puoi elencare tutti gli alloggi che desideri.",
  vous_pouvez__changer_autant_de_fois_que_vous_voulez_dans_l_ann_e_:
    "Scambio senza limite di ricorrenza nel corso dell'anno.",
  chaque__change_repose_sur_un_contrat_clair_entre_deux_h_tes_:
    "Un contratto formale vincola ufficialmente gli host e garantisce il successo.",
  r_f_rences_de_bonnes_pratiques: "Riferimenti sulle migliori pratiche",
  un_club_s_rieux__une_communaut__durable:
    "Un club serio crea una comunità duratura",
  retour_au_guide_complet: "Torna alla guida completa",
  carte_des_logements_traveltrok: "Mappa degli alloggi DONKEY TRAVEL",
  points_logements: "Punti alloggio",
  aucune_donnee_geolocalisee_pour_le_moment_:
    "Nessun dato geolocalizzato al momento.",
  envie_d_entrer_dans_la_carte__: "Vuoi comparire sulla mappa?",
  chargement_des_logements___: "Caricamento alloggio...",
  la_date_d_arriv_e_est_requise: "La data di arrivo è obbligatoria",
  la_date_ne_peut_pas__tre_dans_le_pass_: "La data non può essere nel passato",
  la_date_de_d_part_est_requise: "La data di partenza è obbligatoria",
  la_date_de_d_part_doit__tre_apr_s_l_arriv_e:
    "La data di partenza deve essere successiva all'arrivo",
  le_message_doit_contenir_au_moins_10_caract_res:
    "Il messaggio deve contenere almeno 10 caratteri",
  veuillez_corriger_les_erreurs_ci_dessus:
    "Si prega di correggere gli errori sopra riportati",
  une_erreur_est_survenue__veuillez_r_essayer_:
    "Si è verificato un errore. Per favore riprova.",
  paris__france: "Parigi, Francia",
  mode_h_te: "Modalità ospite",
  je_loue_quelques_semaines_par_an__le_mod_le_1eur___nuit_est_super_simple___expliquer_aux_voyageurs_:
    "Affitto qualche settimana all'anno. Il modello da 1 EUR a notte è semplicissimo da spiegare ai viaggiatori.",
  "37_nuits": "37 notti",
  lyon__france: "Lione, Francia",
  mode_voyageur: "La moda dei viaggiatori",
  la_r_servation_est_fluide__et_surtout_les_frais_sont_lisibles__je_compare_facilement_le_co_t_final_avant_de_confirmer_:
    "La prenotazione è fluida e soprattutto le tariffe sono leggibili. Confronto facilmente il costo finale prima di confermare.",
  "22_nuits": "22 notti",
  bordeaux__france: "Bordeaux, Francia",
  "54_nuits": "54 notti",
  marseille__france: "Marsiglia, Francia",
  pro_multi_logements: "Pro multiabitazione",
  avec_plusieurs_biens__la_version_pro_me_fait_gagner__norm_ment_de_temps_sur_le_calendrier_et_la_gestion_des_demandes_:
    "Con più proprietà, la versione Pro mi fa risparmiare molto tempo nella pianificazione e nella gestione delle richieste.",
  "9_logements": "9 alloggi",
  retours_utilisateurs: "Feedback degli utenti",
  des_retours_terrain_concrets: "Feedback sul campo concreto",
  des_voyageurs_et_h_tes_qui_veulent_une_location_plus_claire_et_plus_abordable_:
    "Viaggiatori e host che desiderano un noleggio più chiaro e conveniente.",
  activit_: "attività",
  _conomie_estim_e: "risparmio stimato",
  profils_et_logements_v_rifi_s: "Profili e alloggi verificati",
  exp_rience_location_simplifi_e: "Esperienza di noleggio semplificata",
  co_ts_transparents___la_nuit: "Costi trasparenti di notte",
  marquer_des_dates: "Segna le date",
  je_peux_accueillir: "Posso ospitare",
  je_veux_partir: "Voglio andarmene",
  partir_et_accueillir: "Partenza e Benvenuto",
  accueillir: "Dare il benvenuto",
  partir: "Partire",
  bloquer_les_dates: "Blocca le date",
  toujours_partir_et_accueillir: "Parti sempre e benvenuto",
  rendre_ce_logement_visible: "Rendi visibile questo alloggio",
  rendre_ce_logement_invisible: "Rendi invisibile questo alloggio",
  confirmation_visibilite_logement:
    "Sei sicuro di voler modificare la visibilità di QUESTA inserzione per gli altri membri?",
  confirmer_activer_toujours_partir_accueillir:
    "Attivando questa modalità verranno aggiunte nuove disponibilità 'Leave and Welcome' per coprire sempre i prossimi 2 anni da oggi. Le altre disponibilità manuali verranno sovrascritte.\n\nSei sicuro di voler continuare?",
  confirmer_desactiver_toujours_partir_accueillir:
    'Sei sicuro di voler disattivare la modalità "Lascia e saluta sempre"?',
  details_de_l_adresse__optionnel_: "Dettagli dell'indirizzo (facoltativo)",
  rue_et_numero: "Via e numero",
  ex__12_rue_de_la_paix: "Esempio: 12 rue de la Paix",
  appartement_suite: "Appartamento, suite, ecc.",
  ex__apt_4b: "Esempio: appartamento 4B",
  etage: "Pavimento",
  ex__3eme_sans_ascenseur: "Esempio: 3°",
  code_d_acces: "Codice di accesso (porta/edificio)",
  ex__a1234: "Esempio: A1234",
  ces_informations_ne_seront_partagees_qu_avec_les_voyageurs_confirmes:
    "Queste informazioni dettagliate verranno comunicate solo ai membri che hanno uno scambio confermato con te.",
  lits_doubles: "Letti matrimoniali",
  lits_simples: "Letti singoli",
  canapes_lits: "Divani letto",
  lits_bebes: "Lettini per bambini",
  amenity_cat_essentials: "L'essenziale",
  amenity_cat_kitchen: "Cucina e pasti",
  amenity_cat_bathroom: "Bagno",
  amenity_cat_bedroom_laundry: "Camera da letto e biancheria",
  amenity_cat_entertainment: "Divertimento",
  amenity_cat_family: "Famiglia",
  amenity_cat_exterior: "Al di fuori",
  amenity_cat_features: "Caratteristiche",
  amenity_cat_location: "Posizione",
  amenity_cat_safety: "Sicurezza",
  amenity_wifi: "Wifi",
  amenity_workspace: "Spazio di lavoro dedicato",
  amenity_ac: "Aria condizionata",
  amenity_heating: "Riscaldamento",
  amenity_kitchen: "Cucina",
  amenity_refrigerator: "Frigo",
  amenity_microwave: "Microonde",
  amenity_oven: "Forno",
  amenity_dishwasher: "Lavastoviglie",
  amenity_coffee_maker: "Macchina da caffè",
  amenity_kettle: "Bollitore",
  amenity_bathtub: "Vasca",
  amenity_hair_dryer: "asciugacapelli",
  amenity_shampoo: "Shampoo e gel doccia",
  amenity_hot_water: "Acqua calda",
  amenity_washing_machine: "Lavatrice",
  amenity_dryer: "Asciugatrice",
  amenity_iron: "Ferro",
  amenity_hangers: "Grucce",
  amenity_bed_linens: "Biancheria da letto fornita",
  amenity_tv: "Televisione",
  amenity_game_console: "Consolle di gioco",
  amenity_books_toys: "Libri e giocattoli",
  amenity_sound_system: "Sistema audio",
  amenity_high_chair: "Seggiolone",
  amenity_baby_bath: "Bagnetto per bambini",
  amenity_travel_cot: "Lettino da viaggio",
  amenity_changing_table: "Fasciatoio",
  amenity_patio: "Balcone o terrazza",
  amenity_garden: "Giardino privato",
  amenity_bbq: "Barbecue",
  amenity_outdoor_furniture: "Mobili da esterno",
  amenity_pool: "Piscina",
  amenity_hottub: "Jacuzzi",
  amenity_gym: "Palestra",
  amenity_fireplace: "Camino",
  amenity_breakfast: "Colazione inclusa",
  amenity_parking: "Parcheggio gratuito",
  amenity_ev_charger: "Stazione di ricarica per veicoli elettrici",
  amenity_beachfront: "Accesso alla spiaggia",
  amenity_ski_in_out: "Accesso alle piste da sci",
  amenity_lake_access: "Accesso al lago",
  amenity_smoke_detector: "Rilevatore di fumo",
  amenity_first_aid: "Kit di pronto soccorso",
  amenity_fire_extinguisher: "Estintore",
  amenity_sauna: "Sauna",
  amenity_massage_chair: "Poltrona da massaggio",
  amenity_shower: "Doccia",
  amenity_home_cinema: "Cinema domestico",
  amenity_ping_pong: "Tavolo da ping pong",
  amenity_forest_access: "Accesso alla foresta",
  amenity_hiking_access: "Accesso alle escursioni",
  compl_t_: "completato",
  l_adresse_doit_tre_localis_e_sur_la_carte:
    "L'indirizzo deve essere localizzato sulla mappa",
  au_moins_3_photos_requises: "Sono necessarie almeno 3 foto",
  le_titre_doit_faire_au_moins_10_caract_res:
    "Il titolo deve contenere almeno 10 caratteri",
  la_description_doit_faire_au_moins_50_caract:
    "La descrizione deve essere lunga almeno 50 caratteri",
  s_lectionnez_au_moins_3_quipements: "Seleziona almeno 3 attrezzature",
  encore_quelques_d_tails_avant_de_publier:
    "Qualche dettaglio in più prima della pubblicazione",
  votre_annonce_est_compl_t_e_x:
    "Il tuo annuncio è stato completato al {{score}}%. Compila gli elementi mancanti per poterlo pubblicare:",
  compl_ter: "Completare",
  voici_comment_les_voyageurs_verront_votre_:
    "Ecco come i viaggiatori vedranno il tuo annuncio.",
  photo: "Foto",
  afficher_toutes_les_photos: "Mostra tutte le foto",
  h_t_par_vous: "• Ospite: tu",
  description: "Informazioni su questo alloggio",
  votre_description_appara_tra_ici: "La tua descrizione apparirà qui...",
  afficher_les_n__quipements_x: "Mostraglieli{{count}}attrezzatura",
  ajouter_une_date: "Aggiungi una data",
  aucun_montant_ne_vous_sera_d_bit_:
    "Nessun importo ti verrà addebitato in questo momento",
  demander: "Chiedere",
  enregistrer_et_quitter: "Salva ed esci",
  enregistrer_pour_plus_tard: "Risparmia per dopo",
  conseils_pour_des_photos_r_ussies: "Suggerimenti per foto di successo",
  privil_giez_le_format_paysage__1:
    "Scegli il formato orizzontale (16:9) per una migliore visualizzazione.",
  prenez_vos_photos_de_jour__avec_:
    "Scatta le tue foto durante il giorno, con una buona luce naturale.",
  rangez_et_nettoyez_les_pi_ces_av:
    "Conserva e pulisci i pezzi prima di fotografarli.",
  mettez_en_avant_les_atouts_de_vo:
    "Metti in risalto i punti di forza del tuo alloggio (vista, terrazza, bel soggiorno, ecc.).",
  donnez_un_titre___votre_annonce: "Dai un titolo al tuo annuncio",
  un_titre_court_et_accrocheur_attirera_pl:
    "Un titolo breve e accattivante attirerà più viaggiatori.",
  souhaite_visiter: "Vorrei visitare",
  vous_propose_en_change: "Ti offre in cambio",
  autres_logements: "altri alloggi",
  voir_le_logement: "Guarda gli alloggi",
  votre_demande_titre: "La tua richiesta",
  votre_demande_soustitre:
    "Riepilogo dei tuoi desideri di viaggio e compagni per i tuoi futuri scambi.",
  compagnons_de_voyage: "Compagni di viaggio",
  voyage_avec_bebe: "bambini)",
  voyage_avec_animaux: "Animali domestici",
  disponibilites_souhaitees: "Disponibilità desiderata",
  destinations_cibles: "Destinazioni target",
  aucune_date_precisee: "Non è stata specificata alcuna data di viaggio.",
  aucune_destination_precisee:
    "Non è stata specificata alcuna destinazione di destinazione.",
  votre_demande_menu: "La tua richiesta",
  modifier_mon_profil: "Modifica il mio profilo",
  rayon_de: "Raggio di{{km}}km",
  dates_flexibles_option: "Date flessibili",
  animaux_de_compagnie_details: "{{count}}animale/animali",
  changer_d_annonce: "Cambia annuncio",
  profil_du_voyageur: "Profilo del viaggiatore",
  chambres_requises: "Camere richieste",
  animaux: "animale(i)",
  duree_du_sejour_souhaitee: "Durata del soggiorno desiderata",
  combien_de_chambres_avez_vous_besoin__:
    "Di quante camere da letto hai bisogno?",
  combien_de_b_b_s__: "Quanti bambini?",
  combien__: "Quanto ?",
  vos_animaux: "I tuoi animali",
  chien_s_: "Cani",
  plus_de_30_nuits: "Più di 30 notti",
  "community.hero.badge": "La nostra comunità",
  "community.hero.title": "Unisciti alla rete host più autentica",
  "community.hero.subtitle":
    "Condividi più che solo la tua casa. Scopri storie, incontra host appassionati e viaggia in tutta sicurezza.",
  "community.stats.members": "Membri attivi",
  "community.stats.countries": "Paesi rappresentati",
  "community.stats.exchanges": "Scambi effettuati",
  "community.values.title": "Ciò che ci unisce",
  "community.values.trust.title": "Fiducia assoluta",
  "community.values.trust.desc":
    "Ogni membro è un host verificato, garantendo il rispetto reciproco dei locali.",
  "community.values.sharing.title": "Condivisione e riunioni",
  "community.values.sharing.desc":
    "L’opportunità di creare legami con gente del posto in tutta Europa.",
  "community.values.savings.title": "Risparmio reale",
  "community.values.savings.desc":
    "Viaggia più spesso, più lontano, preservando il tuo budget.",
  "community.testimonials.title": "Storie dei membri",
  "community.cta.title": "Pronti a far parte dell'avventura?",
  "community.cta.button": "Diventa un membro oggi",
  "blog.hero.badge": "Il nostro blog",
  "blog.hero.title": "Ispirazione e suggerimenti",
  "blog.hero.subtitle":
    "Scopri storie di viaggio, consigli per preparare il tuo alloggio e le novità del club.",
  "blog.categories.all": "Tutti gli articoli",
  "blog.categories.tips": "Suggerimenti per l'host",
  "blog.categories.inspiration": "Ispirazione di viaggio",
  "blog.categories.news": "Notizia",
  "blog.empty": "Nessun articolo al momento. Torna presto!",
  "help.hero.badge": "Centro assistenza",
  "help.hero.title": "Come possiamo aiutarti?",
  "help.hero.subtitle":
    "Trova risposte rapide o contatta il nostro team di supporto.",
  "help.search.placeholder": "Cerca una risposta...",
  "help.categories.account.title": "Conto e profilo",
  "help.categories.account.desc":
    "Gestisci le tue informazioni, password e preferenze.",
  "help.categories.exchanges.title": "Scambi e prenotazioni",
  "help.categories.exchanges.desc":
    "Come offrire, accettare o annullare uno scambio.",
  "help.categories.trust.title": "Fiducia e sicurezza",
  "help.categories.trust.desc": "Contratti, verifica e tutela dell'abitazione.",
  "help.faq.title": "Domande frequenti",
  "help.contact.cta": "Non hai trovato la tua risposta?",
  "help.contact.button": "Contattaci",
  "careers.hero.badge": "Unisciti alla squadra",
  "careers.hero.title": "Costruiamo il futuro dei viaggi",
  "careers.hero.subtitle":
    "Cerchiamo persone appassionate per ridefinire il modo in cui gli ospiti viaggiano in Europa.",
  "careers.values.title": "I nostri valori",
  "careers.values.trust.title": "Umano e fiducia",
  "careers.values.remote.title": "Telelavoro flessibile",
  "careers.values.impact.title": "Impatto reale",
  "careers.openings.title": "Posizioni aperte",
  "careers.openings.empty":
    "Nessuna posizione attualmente aperta. Non esitate ad inviare una candidatura spontanea!",
  "careers.apply.title": "Candidatura spontanea",
  "careers.apply.desc":
    "Invia il tuo CV e raccontaci come puoi aiutare Donkey Travel.",
  "careers.apply.button": "Invia la mia candidatura",
  "contact.hero.badge": "Contatto",
  "contact.hero.title": "Siamo qui per te",
  "contact.hero.subtitle":
    "Una domanda, un suggerimento o un problema? Il nostro team è pronto ad ascoltarti.",
  "contact.form.name": "Il tuo nome",
  "contact.form.email": "La tua email",
  "contact.form.subject": "Oggetto del tuo messaggio",
  "contact.form.message": "Il tuo messaggio...",
  "contact.form.send": "Invia messaggio",
  "contact.info.title": "Informazioni utili",
  "contact.info.email": "contact@donkey.travel",
  "contact.info.address": "Valle dell'Alta Somme, Piccardia, Francia",
  "contact.info.hours": "Lun - Ven: 9:00 - 18:00",
  activez_votre_abonnement: "Attiva il tuo abbonamento",
  finalisez_votre_inscription: "Finalizza la tua registrazione",
  _changes_illimit_s_en_europe: "Scambi illimitati in Europa",
  validit___1_an: "Validità: 1 anno",
  paiement_100__s_curis__par_paypal: "Pagamento sicuro al 100% tramite PayPal",
  me_d_connecter_et_revenir_plus_tard: "Esci e torna più tardi",
  erreur_lors_de_la_validation_du_paiement_sur_n:
    "Errore durante la convalida del pagamento sui nostri server.",
  le_paiement_n_a_pas_pu__tre_valid_: "Impossibile convalidare il pagamento.",
  une_erreur_inconnue_est_survenue_lors_du_paiem:
    "Si è verificato un errore sconosciuto durante il pagamento.",
  impossible_d_initialiser_paypal__v_rifiez_vot:
    "Impossibile inizializzare PayPal. Controlla la tua connessione.",
  donn_es_personnelles: "Dati personali",
  rejoignez_notre_communaut__et_r_servez_un_logement:
    "Unisciti alla nostra community e prenota un alloggio a {{city}} con tariffe fisse chiare e assicurazione inclusa.",
  bienvenue: "Benvenuto",
  code_promo_applique_avec_succes:
    "Il codice promozionale è stato applicato con successo!",
  cible: "Bersaglio",
  propose: "Proporre",
  "1_sens": "1 senso",
  "2_sens": "2 sensi",
  ils_veulent_visiter_votre_region_br_c_est_a_vous:
    "Vogliono visitare la tua zona.<br />Sta a te scoprire dove vivono!",
  ils_cherchent_chez_vous_et_br_ils_habitent_la_ou:
    "Ti stanno cercando E<br />vivono dove vuoi andare!",
  comment_ca_marche: "Come funziona?",
  comprendre_les_differents_types_de_matching:
    "Comprendere i diversi tipi di abbinamento",
  match_reciproque: "Corrispondenza reciproca",
  details_de_la_demande: "Richiedi dettagli",
  souhaite_venir_dans_votre_secteur: "Vorrei venire nella tua zona:",
  peut_vous_accueillir: "Può ospitarti:",
  souhaite_visiter_dans_un_rayon:
    "Vorrei visitare <strong>{{city}}</strong> in un raggio di <strong>{{radius}} km</strong>, il tuo alloggio corrisponde alla loro ricerca.",
  souhaite_visiter_ville:
    "Vorrei visitare <strong>{{city}}</strong>, il tuo alloggio corrisponde alla loro ricerca.",
  a_besoin_de_chambres: "Richiede {{count}} stanza/e.",
  comparateur_de_valeur: "Comparatore di valori",
  ecart: "spacco",
  code_promo_invalide: "Codice promozionale non valido",
  erreur_verification_code: "Errore durante la verifica del codice",
  vous_avez_un_code_promo: "Hai un codice promozionale?",
  entrez_votre_code: "INSERISCI IL TUO CODICE",
  appliquer: "Applica",
  importation_r_ussie_:
    "Importazione riuscita! Le tue informazioni sono state precompilate.",
  erreur_lors_de_l_importation: "Errore durante l'importazione:",
  d_crivez_ce_qui_rend_votre_logement_uniq:
    "Descrivi cosa rende unica la tua casa...",
  mettez_en_avant_les_points_forts___votre:
    "Evidenzia i punti forti del tuo alloggio",
  lien_annonce_airbnb_1: "Link al tuo annuncio Airbnb",
  importation___: "Importare...",
  importer_l_annonce: "Importa annuncio",
  renseignez_le_lien_de_votre_annonce_pou_:
    "Inserisci il link al tuo annuncio. Puoi importare i dettagli automaticamente per risparmiare tempo.",
  lien_calendrier_airbnb: "Collegamento al calendario (iCal)",
  nous_utiliserons_ce_lien_pour_synchroni:
    "Utilizzeremo questo collegamento per sincronizzare la tua disponibilità.",
  entrer_en_contact: "Mettiti in contatto",
  attention___risque__lev__de_d_pendance_aux_voyages_gratuits__:
    "Attenzione: alto rischio di dipendenza dai viaggi gratuiti!",
};
